// The account/utility-page side nav now lives in tsi-common-react so the shared
// account document bodies can reuse it (#33285). Re-exported here so the other
// pillows account/utility templates keep importing it from this path unchanged.
export { SideNav } from "tsi-common-react/src/apps/customer-account/SideNav/index";
